import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useUserSWR from '../../hooks/user/useUserSWR';
import { UnderConstructionLayout } from '../layouts/UnderConstructionLayout';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

const LockGuard = () => {
    const { user, isLoading, isError } = useUserSWR();
    const { t } = useTranslation();

    if (isLoading) {
        return <></>;
    }

    if (isError) {
        // return <Typography>{t('LOCK_SCREEN.ERROR')}</Typography>;
        return <Navigate to={'/profile'} replace />;
    }
// <UnderConstructionLayout />
    return user.is_admin ? <Outlet /> : <Navigate to={'/profile'} replace />;
};

export default LockGuard;
